import { lazy, Suspense } from 'react';

const FederatedAppOutlet = __CREST_MF_ENABLED__
  ? lazy(() =>
      import('./FederatedAppOutlet.js').then((module) => ({
        default: module.FederatedAppOutlet,
      })),
    )
  : undefined;
/** 构建时隔离运行时：standalone 不装载子应用，MF 构建装入 Remote outlet。 */
export function MicroFrontendOutlet() {
  const RuntimeOutlet = FederatedAppOutlet;
  if (!RuntimeOutlet) {
    return (
      <output className="micro-app-unavailable">
        当前为 Platform 独立构建，未启用业务子应用装配。
      </output>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="micro-app-loading" aria-live="polite">
          正在初始化微前端运行时…
        </div>
      }
    >
      <RuntimeOutlet />
    </Suspense>
  );
}
